module.exports = __webpack_public_path__ + "static/media/9.903b55f1.png";